import moment from 'moment';
import _ from 'lodash';

import { ItemEnum } from 'Common/FieldEnum';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { KitchenItemPrepareInHouseFilterEnum } from 'Common/GridHelper';
import { makeOptionsDataRemoveEmpty } from 'Common/FormHelper';

import * as types from './types';

const INITIAL_STATE = {
  transferItems: [],
  toSites: [],
  fetchingTransferItems: false,
  fetchTransferDetailError: null,
  selectedTransferDetail: null,
  fetchingTransferDetail: false,
  transferItemsLoadingError: null,
  submitted: false,
  submitError: null,
  submitting: false,
  loading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.CREATE_EDIT_TRANSFER_ITEMS_LOADING:
      return {
        ...state,
        fetchingTransferItems: action.payload,
      };

    case types.CREATE_EDIT_TRANSFER_ITEMS:
      return {
        ...state,
        transferItems: action.payload.map(item => ({
          ...item,
          [ItemEnum.SecQty]: item[ItemEnum.SecQty]
            ? Number(item[ItemEnum.SecQty]).toFixed(4)
            : '',
          [ItemEnum.BeginDate]: item[ItemEnum.BeginDate]
            ? moment(item[ItemEnum.BeginDate]).format(DATE_FORMAT_FOR_UI)
            : '',
          [ItemEnum.EndDate]: item[ItemEnum.EndDate]
            ? moment(item[ItemEnum.EndDate]).format(DATE_FORMAT_FOR_UI)
            : '',
          [ItemEnum.PriQty]: null,
          [ItemEnum.SecQty]: null,
          [ItemEnum.PrepareInHouse]:
            typeof item[ItemEnum.PrepareInHouse] === 'string'
              ? item[ItemEnum.PrepareInHouse]
              : item[ItemEnum.PrepareInHouse]
              ? KitchenItemPrepareInHouseFilterEnum.Yes
              : KitchenItemPrepareInHouseFilterEnum.No,
        })),
      };

    case types.VIEW_TRANSFER_ITEMS:
      return {
        ...state,
        transferItems: action.payload.map(item => ({
          ...item,
          [ItemEnum.SecQty]: item[ItemEnum.SecQty]
            ? Number(item[ItemEnum.SecQty]).toFixed(4)
            : '',
          [ItemEnum.BeginDate]: item[ItemEnum.BeginDate]
            ? moment(item[ItemEnum.BeginDate]).format(DATE_FORMAT_FOR_UI)
            : '',
          [ItemEnum.EndDate]: item[ItemEnum.EndDate]
            ? moment(item[ItemEnum.EndDate]).format(DATE_FORMAT_FOR_UI)
            : '',
          [ItemEnum.PrepareInHouse]: item[ItemEnum.PrepareInHouse]
            ? KitchenItemPrepareInHouseFilterEnum.Yes
            : KitchenItemPrepareInHouseFilterEnum.No,
        })),
      };

    case types.TRANSFER_ITEMS_LOADING_ERROR:
      return {
        ...state,
        transferItemsLoadingError: action.payload,
      };

    case types.FETCHING_TRANSFER_DETAIL:
      return {
        ...state,
        fetchingTransferDetail: action.payload,
      };

    case types.FETCHING_TRANSFER_DETAIL_ERROR:
      return {
        ...state,
        fetchTransferDetailError: action.payload,
      };

    case types.SELECTED_TRANSFER_DETAIL:
      return {
        ...state,
        selectedTransferDetail: action.payload,
      };

    case types.CLEAR_TRANSFER_ERROR_SUCCESS:
      return {
        ...state,
        submitted: false,
        submitError: null,
        fetchTransferDetailError: null,
        transferItemsLoadingError: null,
      };

    case types.SUBMITTING_TRANSFER_DETAIL:
      return {
        ...state,
        submitting: action.payload,
      };

    case types.TRANSFER_DETAIL_SUBMIT:
      return {
        ...state,
        submitted: true,
      };

    case types.SUBMIT_TRANSFER_DETAIL_ERROR:
      return {
        ...state,
        submitError: action.payload,
      };
    case types.RE_TRANSFER_ITEM_LIST:
      let clone = _.clone(state.transferItems, true);
      let remainedItem = [];
      if (action.payload && action.payload.length) {
        _.forEach(action.payload, item => {
          const index = _.findIndex(clone, function(cloneItem) {
            return item.ItemCode === cloneItem.ItemCode;
          });
          if (index !== -1) {
            remainedItem.push(clone[index]);
            clone.splice(index, 1);
          }
        });
      }
      clone = _.concat(remainedItem, clone);
      return {
        ...state,
        transferItems: clone,
      };

    case types.GET_TO_SITES:
      const siteOptions = makeOptionsDataRemoveEmpty(action.payload, true);

      return { ...state, toSites: siteOptions };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/transfer/state/createEditTransfer/reducer.js